module.exports = __webpack_public_path__ + "img/default-profil-picture.f53f21e1.png";